var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rows === 0 && !_vm.isBusy
    ? _c("b-container", [
        _c("strong", [_vm._v("There are not defined rules for this table")]),
      ])
    : _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c("b-table", {
                staticClass: "mt-3",
                attrs: {
                  id: "main-table",
                  items: _vm.items,
                  fields: _vm.fields,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  outlined: "",
                  responsive: "",
                  hover: "",
                  "show-empty": "",
                  small: true,
                  busy: _vm.isBusy,
                  "sticky-header": true,
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function () {
                      return [_c("base-loading")]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(creationTime)",
                    fn: function (data) {
                      return [
                        data.item.creationTime
                          ? _c("div", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("stringShortFormatDateStick")(
                                    " " + data.item.creationTime + " "
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(finishTime)",
                    fn: function (data) {
                      return [
                        data.item.finishTime
                          ? _c("div", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("stringLongFormatDateStick")(
                                    " " + data.item.finishTime + " "
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.bottom",
                                value: "View",
                                expression: "'View'",
                                modifiers: { hover: true, bottom: true },
                              },
                            ],
                            staticClass: "ml-2",
                            attrs: { size: "sm", variant: "outline-primary" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("viewDetail", data.item)
                              },
                            },
                          },
                          [_c("b-icon-eye")],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("pagination-basic", {
                    attrs: { pagination: _vm.pagination },
                    on: { changePagina: _vm.changePage },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }